export { formatCurrency } from '../Items/utils';

const CYCLE_LABELS = {
  30: 'Mensal',
  90: 'Trimestral',
  180: 'Semestral',
  365: 'Anual',
};

export const SALE_TYPE_LABELS = {
  BOTH: 'Plano e avulso',
  ADD_ON: 'Add-on',
  SINGLE_PURCHASE: 'Compra única',
};

export const PAYMENT_METHOD_LABELS = {
  CREDIT_CARD: 'Cartão de crédito',
  PIX: 'Pix',
  BOLETO: 'Boleto',
};

export const formatCycle = (days) => CYCLE_LABELS[days] || `${days} dias`;

// Agrupa por cycleDays, com mensal (30) sempre primeiro; demais ciclos em
// ordem crescente. Assume `plans` já ordenado (ex.: por preço) — a ordem
// dentro de cada grupo segue a da lista recebida.
export function groupPlansByCycle(plans) {
  const groups = new Map();

  plans.forEach((plan) => {
    const list = groups.get(plan.cycleDays) || [];
    list.push(plan);
    groups.set(plan.cycleDays, list);
  });

  return [...groups.entries()]
    .map(([cycleDays, plansInGroup]) => ({ cycleDays, plans: plansInGroup }))
    .sort((a, b) => {
      if (a.cycleDays === 30) return -1;
      if (b.cycleDays === 30) return 1;
      return a.cycleDays - b.cycleDays;
    });
}

// benefitsType do planItem pode vir null; item.benefitType é o fallback.
export const getBenefitType = (planItem) =>
  planItem.benefitsType ?? planItem.item?.benefitType;

export function formatBenefit(planItem) {
  const type = getBenefitType(planItem);
  const { itemTotal } = planItem;

  if (type === 'INCLUDED') return 'Incluso';
  if (type === 'CREDITS' && itemTotal != null) {
    return `${itemTotal} ${planItem.item?.unit || ''}`.trim();
  }
  // Item de crédito liberado como acesso, sem limite
  if (type === 'ACCESS' && planItem.item?.benefitType === 'CREDITS') {
    return 'Ilimitado';
  }
  return 'Acesso';
}

// Linhas = união dos itens de todos os planos (por code); cada coluna é um
// plan.id. `diff` marca linhas onde o valor varia entre os planos comparados
// (inclui o caso de o item nem existir em algum deles, tratado como '—').
export function buildComparisonRows(plans) {
  const byCode = new Map();

  plans.forEach((plan) => {
    plan.planItems?.forEach((planItem) => {
      const { id, code, name } = planItem.item;
      const row = byCode.get(code) || { id, code, name, values: {} };
      row.values[plan.id] = formatBenefit(planItem);
      byCode.set(code, row);
    });
  });

  return [...byCode.values()]
    .map((row) => {
      const values = plans.map((plan) => row.values[plan.id] || '—');
      return { ...row, diff: values.some((value) => value !== values[0]) };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}
